export const SITE = {
  name: "Tijuas Tacos Birrieria",
  shortName: "Tijuas Tacos",
  legalName: "Tijuas Tacos LLC",
  domain: "https://tijuastacosnm.com",
  phone: "505-417-3431",
  phoneDisplay: "(505) 417-3431",
  phoneE164: "+15054173431",
  email: "operations@tijuastacosnm.com",
  address: {
    street: "5505 Osuna Rd NE",
    city: "Albuquerque",
    state: "NM",
    zip: "87109",
    full: "5505 Osuna Rd NE, Albuquerque, NM 87109",
  },
  geo: { lat: 35.1303, lng: -106.5647 },
  mapsUrl: "https://maps.google.com/?q=5505+Osuna+Rd+NE+Albuquerque+NM+87109",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=5505+Osuna+Rd+NE+Albuquerque+NM+87109",
  mapsEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3260.5!2d-106.5647!3d35.1303!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87220cbd7d0d3e33%3A0x1e2e9e51c3f74e8!2s5505%20Osuna%20Rd%20NE%2C%20Albuquerque%2C%20NM%2087109!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus",
  orderUrl: "https://order.online/business/~15049275/",
  appStoreUrl: "https://apps.apple.com/us/app/tijuas-tacos-birrieria/id6807185070",
  facebook: "https://www.facebook.com/tijuas.tacos.505",
  instagram: "https://www.instagram.com/tijuas_birria_tacos/",
  googleReviewsUrl: "https://maps.app.goo.gl/4Psaqzoi8DNEzL3u5",
  scripture:
    '"For it is God who works in you to will and to act in order to fulfill his good purpose." — Philippians 2:13',
};

// 0 = Sunday ... 6 = Saturday. open/close in 24h local (America/Denver).
export const HOURS = [
  { day: 0, closed: true },
  { day: 1, closed: true },
  { day: 2, open: 11, close: 21 },
  { day: 3, open: 11, close: 21 },
  { day: 4, open: 11, close: 21 },
  { day: 5, open: 11, close: 22 },
  { day: 6, open: 11, close: 22 },
];

export const IMAGES = {
  logo: "/images/logo.webp",
  hero: "/images/quesabirria-hero.webp",
  heroMobile: "/images/quesabirria-hero-mobile.webp",
  og: "/images/og-image.jpg",
  quesabirria: "/images/quesabirria.webp",
  quesabirriaPlate: "/images/quesabirria-hero.webp",
  tacosDorados: "/images/tacos-dorados.webp",
  birriaRamen: "/images/birria-ramen.webp",
  birriaPizza: "/images/birria-pizza.webp",
  birriaFries: "/images/birria-fries.webp",
  quesazilla: "/images/quesazilla.webp",
  softTacos: "/images/soft-tacos.webp",
  birriaBurrito: "/images/birria-burrito.webp",
  chilaquiles: "/images/chilaquiles.webp",
  quesaLoca: "/images/quesa-loca.webp",
  birriaNachos: "/images/birria-nachos.webp",
  menuBoard:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_tijuana-tacos/artifacts/igto9312_el-tijuas-tacos-menu%20final3%281920%20x%201080%20px%29.png",
  cateringBoard:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_tijuana-tacos/artifacts/hc2rl7tt_el-tijuas-tacos-catering-packages%2824%20x%2036%20in%29.webp",
};

// Tracking IDs come from env placeholders. Leave empty until the owner provides real IDs.
export const TRACKING = {
  ga4: process.env.REACT_APP_GA4_MEASUREMENT_ID || "",
  googleAdsId: process.env.REACT_APP_GOOGLE_ADS_ID || "",
  googleAdsLabel: process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL || "",
  metaPixel: process.env.REACT_APP_META_PIXEL_ID || "",
};
